import { Component, Input } from '@angular/core';
import { LoadingService } from 'ng-devui';
import { zip, catchError, throwError } from 'rxjs';
import { DialogConfig } from 'src/app/modules/shared/components/alert-dialog/dialog-config';
import { ArchiveCatalog } from 'src/app/modules/shared/models/archive/archive-catalog.model';
import { ArchiveFileSyncRuleType } from 'src/app/modules/shared/models/archive/archive-file-sync-rule-type.enum';
import { ArchiveFileSyncRule } from 'src/app/modules/shared/models/archive/archive-file-sync-rule.model';
import { FileType } from 'src/app/modules/shared/models/form/file-type.enum';
import { MaterialType } from 'src/app/modules/shared/models/material/material-type.model';
import { ProjectSection } from 'src/app/modules/shared/models/project/project-section.model';
import { FileResponse } from 'src/app/modules/shared/providers/request/file-response.model';
import { ArchiveCatalogService } from 'src/app/modules/shared/services/archive-catalog.service';
import { CommonService } from 'src/app/modules/shared/services/common.service';
import { MaterialTypeService } from 'src/app/modules/shared/services/material-type.service';
import { ProjectSectionService } from 'src/app/modules/shared/services/project-section.service';
import { ProjectWbsService } from 'src/app/modules/shared/services/project-wbs.service';

@Component({
  selector: 'app-dialog-profiles-volume-upload',
  templateUrl: './dialog-profiles-volume-upload.component.html',
  styleUrls: ['./dialog-profiles-volume-upload.component.scss'],
})
export class DialogProfilesVolumeUploadComponent {
  @Input()
  data!: DialogConfig<ArchiveCatalog>;

  editing: { [name: string]: boolean } = {};

  record: ArchiveCatalog = new ArchiveCatalog();

  excel = FileType.EXCEL;
  pdf = FileType.PDF;

  pdfUrl: string = '';
  pdfName: string = '';
  excelUrl: string = '';
  excelName: string = '';

  constructor(
    private archiveCatalogService: ArchiveCatalogService,
    private commonService: CommonService,
    private loadingService: LoadingService,
  ) {}

  ngOnInit() {}

  isNaN(content: number) {
    return window.isNaN(content);
  }

  cancel() {
    this.data.onCancel();
  }

  confirm() {
    this.submit();
  }

  get canConfirm() {
    return !!this.pdfUrl && !!this.excelUrl;
  }

  onFileSelected(event: any, type: FileType) {
    const files: FileList = event.target['files'];
    this.commonService
      .uploadFileWithoutProgress(files[0])
      .subscribe((file: FileResponse) => {
        event.target['value'] = '';
        if (type === FileType.PDF) {
          if (file.fileName.endsWith('.pdf')) {
            this.pdfUrl = file.fileUrl;
            this.pdfName = file.fileName;
          }
        } else if (type === FileType.EXCEL) {
          if (
            file.fileName.endsWith('.xls') ||
            file.fileName.endsWith('.xlsx')
          ) {
            this.excelUrl = file.fileUrl;
            this.excelName = file.fileName;
          }
        }
      });
  }

  private submit() {
    this.data.onConfirm!(<ProfilesVolumeUploadResult>{
      pdfUrl: this.pdfUrl,
      pdfName: this.pdfName,
      excelUrl: this.excelUrl,
      excelName: this.excelName,
    });
  }
}

export interface ProfilesVolumeUploadResult {
  pdfUrl: string;
  pdfName: string;
  excelUrl: string;
  excelName: string;
}
